import React, { useState, useEffect } from 'react';
import { getLegacyApiUrl } from '../utils/apiUtils';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${getLegacyApiUrl()}/auth/me`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await response.json();
        setUserData(data.user);
      } catch (error) {
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{width: '100%', height: '100%', position: 'relative', background: 'white', overflow: 'hidden'}}>
      <Sidebar />
      
      <div style={{marginLeft: 290, width: 'calc(100% - 290px)', minHeight: '100vh', background: 'white', position: 'relative'}}>
        <Header />
        
        <div style={{padding: '20px 40px'}}>
          <h1 style={{fontSize: 24, fontFamily: 'Outfit', fontWeight: '500', color: '#131A1A'}}>Profile</h1>
        </div>

        <div style={{width: 800, margin: '0 auto'}}>
          <div style={{position: 'relative', marginBottom: '80px'}}>
            {/* Cover Image */}
            <div style={{width: '100%', height: 160}}>
              <img 
                src="/assets/Content.png" 
                alt="Cover" 
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: 16,
                  border: '1px solid #A8B9CA',
                  objectFit: 'cover'
                }}
              />
            </div>
            
            {/* Profile Image */}
            <div style={{
              position: 'absolute',
              bottom: -48,
              left: '50%',
              transform: 'translateX(-50%)'
            }}>
              <div 
                style={{
                  width: 96,
                  height: 96,
                  borderRadius: '50%',
                  border: '3px solid #FBFCFE',
                  background: '#F04915',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 36,
                  fontWeight: '700',
                  color: 'white',
                  fontFamily: 'Outfit, sans-serif'
                }}
              >
                {userData?.name ? userData.name.charAt(0).toUpperCase() : 'U'}
              </div>
            </div>
          </div>

          {/* Profile Info */}
          <div style={{textAlign: 'center', marginBottom: '40px'}}>
            <h2 style={{color: '#F04915', fontSize: 20, fontFamily: 'Outfit', fontWeight: '500', marginBottom: '4px'}}>{userData?.name}</h2>
            <div style={{color: '#798AA3', fontSize: 16, fontFamily: 'Outfit', fontWeight: '400', marginBottom: '4px'}}>@{userData?.email?.split('@')[0]}</div>
            <div style={{color: '#131A1A', fontSize: 18, fontFamily: 'Poppins', fontWeight: '400'}}>{userData?.role}</div>
          </div>

          {/* ID Section */}
          <div style={{textAlign: 'center', marginBottom: '40px'}}>
            <div style={{fontSize: 24, fontFamily: 'Outfit', fontWeight: '500', color: '#131A1A'}}>
              {userData?.university_id || userData?.student_id || userData?.employee_id}
            </div>
            <div style={{color: '#798AA3', fontSize: 18, fontFamily: 'Outfit', fontWeight: '400'}}>
              {userData?.role === 'admin' ? 'Admin ID' : userData?.role === 'student' ? 'Student ID' : 'Employee ID'}
            </div>
          </div>

          {/* Personal Information Section */}
          <div style={{marginBottom: '16px', borderRadius: 8, borderLeft: '8px solid #F04915', overflow: 'hidden'}}>
            <div style={{background: '#E9F0F4', padding: '8px 16px', borderBottom: '1px solid #A8B9CA'}}>
              <h3 style={{fontSize: 20, fontFamily: 'Outfit', fontWeight: '500', color: '#131A1A'}}>Account Information</h3>
            </div>
            <div style={{padding: '16px'}}>
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px'}}>
                <InfoBlock label="Full Name" value={userData?.name} />
                <InfoBlock label="Email" value={userData?.email} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Helper component for info blocks
const InfoBlock = ({ label, value }) => (
  <div style={{marginBottom: '16px'}}>
    <div style={{color: '#798AA3', fontSize: 18, fontFamily: 'Outfit', fontWeight: '400', marginBottom: '4px'}}>{label}</div>
    <div style={{color: '#131A1A', fontSize: 22, fontFamily: 'Outfit', fontWeight: '400'}}>{value}</div>
  </div>
);

export default Profile;
